module.exports = __webpack_public_path__ + "static/img/coins-2.f812a9d4.png";